import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subtract",
  "use": "icon-subtract-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-subtract\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17,11v2H7V11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol